import { AxiosResponse } from "axios";

export type WhatsappAPIError = AxiosResponse<
  | { errors: { field: string; message: string }[] }
  | {
      error: {
        code?: number;
        error_subcode?: number;
        error_user_msg?: string;
        error_user_title?: string;
        fbtrace_id?: string;
        is_transient?: boolean;
        message?: string;
        type?: string;
        error_data?: {
          details: string;
          messaging_product: string;
        };
      };
    }
>;

export function isWhatsappApiError(error: unknown): error is WhatsappAPIError {
  if (
    error &&
    typeof error === "object" &&
    "data" in error &&
    typeof (error as AxiosResponse).data === "object"
  ) {
    const { data } = error as AxiosResponse;

    if (
      "errors" in data &&
      Array.isArray(data.errors) &&
      data.errors.every(
        (e: { field: string; message: string }) =>
          typeof e.field === "string" && typeof e.message === "string"
      )
    ) {
      return true;
    }
    if ("error" in data && typeof data.error === "object") {
      return true;
    }
  }

  return false;
}
